import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { HOMEPAGE_SNAP_SECTIONS } from "../../utils";
import { Carousel } from "../Carousel";
import {
  CarouselTile,
  TileImageContainer,
  TileImage,
  TileContent,
} from "../CarouselTile";
import { Section, SectionTitle, SectionDescription } from "../Section";
import styles from "./CarsSection.module.scss";
import { useCarsSectionBanners } from "./hooks";
import { getCarBrandImageUrl, getLogoImageUrl } from "@/utils/banners/images";

export const CarsSection = () => {
  const { t } = useI18nContext();
  const [, cn] = useModuleBEM(styles, "CarsSection");
  const { mainSection, carouselSection } = useCarsSectionBanners();

  if (mainSection.length === 0 && carouselSection.length === 0) {
    return null;
  }

  return (
    <Section id={HOMEPAGE_SNAP_SECTIONS.CARS}>
      <SectionTitle as="h1">{t("home.carsSection.title")}</SectionTitle>
      <SectionDescription>
        {t("home.carsSection.description")}
      </SectionDescription>
      <div className={cn("content")}>
        <div className={cn("main-items-container")}>
          {mainSection.map((banner) => {
            const heroImagePath = getCarBrandImageUrl(banner.imageFile);
            const logoImagePath = getLogoImageUrl(banner.logoFile);

            return (
              <a
                key={banner.name}
                href={banner.linkTarget}
                target="_blank"
                rel="noopener"
                referrerpolicy="no-referrer-when-downgrade"
                className={cn("main-deal-link")}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <CarouselTile className={cn("main-deal-item")}>
                  <TileImageContainer
                    className={cn("main-deal-item-image-container")}
                  >
                    <TileImage src={heroImagePath} alt={banner.headerCopy} />
                  </TileImageContainer>
                  <TileContent>
                    <div className={cn("logo-overlay")}>
                      <img className={cn("logo")} src={logoImagePath} alt="" />
                    </div>
                    <div className={cn("title-container")}>
                      <h3
                        className={cn("main-deal-item-title")}
                        data-carousel-title
                      >
                        {banner.headerCopy}
                      </h3>
                    </div>
                  </TileContent>
                </CarouselTile>
              </a>
            );
          })}
        </div>
        <div className={cn("carousel-container")}>
          <Carousel
            items={carouselSection.map((banner) => {
              const heroImagePath = getCarBrandImageUrl(banner.imageFile);
              const logoImagePath = getLogoImageUrl(banner.logoFile);

              return (
                <a
                  key={banner.name}
                  href={banner.linkTarget}
                  target="_blank"
                  rel="noopener"
                  referrerpolicy="no-referrer-when-downgrade"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    display: "block",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <CarouselTile>
                    <TileImageContainer>
                      <TileImage src={heroImagePath} alt={banner.headerCopy} />
                    </TileImageContainer>
                    <TileContent>
                      <div className={cn("logo-overlay")}>
                        <img
                          className={cn("logo")}
                          src={logoImagePath}
                          alt=""
                        />
                      </div>
                      <div className={cn("title-container")}>
                        <h3 className={cn("title")} data-carousel-title>
                          {banner.headerCopy}
                        </h3>
                      </div>
                    </TileContent>
                  </CarouselTile>
                </a>
              );
            })}
          />
        </div>
      </div>
    </Section>
  );
};
